import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Typography from '@material-ui/core/Typography'
import ArrowBackIcon from 'components/material-symbol/icons/ArrowBack'
import ChannelEmbed from 'components/stream-messaging/channel-embed'
import { PGA_COM_HOST } from 'env'
import useRegistrationStyles from '../../register/registration-with-payment-intents/redesign/styles'
import EventSummary from './event-summary'
import HostHeader from './host-header'
import useStyles from './styles'

const MessagesView = ({ event, channel }) => {
  const classes = useRegistrationStyles()
  const messageClasses = useStyles()

  return (
    <div className={classes.page}>
      <div className={classes.inner}>
        <a
          className={classes.backLink}
          href={`${PGA_COM_HOST}/things-to-do/events/${event.slug}`}
        >
          <ArrowBackIcon aria-hidden="true" />
          Back to event
        </a>
        <header className={classes.header}>
          <Typography variant="h3" component="h1" className={classes.title}>
            Message your host
          </Typography>
        </header>

        <div className={classes.grid}>
          <div className={classes.mainCol}>
            <section
              className={messageClasses.chatCard}
              aria-label="Conversation with event host"
            >
              <HostHeader coach={event.coach} />
              <div className={messageClasses.chatBody}>
                <div className={messageClasses.chatBodyInner}>
                  <ChannelEmbed channel={channel} />
                </div>
              </div>
            </section>
          </div>
          <aside
            className={clsx(classes.sideCol, classes.sideColFirstOnMobile)}
          >
            <EventSummary event={event} />
          </aside>
        </div>
      </div>
    </div>
  )
}

MessagesView.propTypes = {
  event: PropTypes.object.isRequired,
  channel: PropTypes.object.isRequired,
}

export default MessagesView
